import type { PanelName } from "../../types.ts";

type NavItem = {
  panel: PanelName;
  label: string;
  icon: string;
  badge?: string | null;
};

type NavGroup = {
  title?: string;
  items: NavItem[];
};

type JampackSidebarProps = {
  activePanel: PanelName;
  isAdmin: boolean;
  collapsed: boolean;
  status: string;
  chatBadge?: string | null;
  calendarBadge?: string | null;
  onSelect: (panel: PanelName) => void;
  onToggleCollapsed: () => void;
};

export function JampackSidebar({
  activePanel,
  isAdmin,
  collapsed,
  status,
  chatBadge,
  calendarBadge,
  onSelect,
  onToggleCollapsed,
}: JampackSidebarProps) {
  const groups: NavGroup[] = [
    {
      title: "Principal",
      items: [
        { panel: "kanban", label: "Funil", icon: "bi-kanban" },
        { panel: "chats", label: "Conversas", icon: "bi-chat-dots", badge: chatBadge },
        { panel: "calendar", label: "Calendário", icon: "bi-calendar3", badge: calendarBadge },
      ],
    },
    {
      title: "Ferramentas",
      items: [
        { panel: "automacao", label: "Automação", icon: "bi-robot" },
        { panel: "shortcuts", label: "Atalhos", icon: "bi-lightning-charge" },
        { panel: "settings", label: "Configuração", icon: "bi-gear" },
      ],
    },
  ];

  if (isAdmin) {
    groups.push({ title: "Sistema", items: [{ panel: "admin", label: "Admin", icon: "bi-shield-lock" }] });
  }

  const connected = status === "connected";

  return (
    <aside className="hk-sidebar" aria-label="Navegação principal">
      <div className="hk-sidebar-head">
        <button
          type="button"
          className="hk-brand-btn"
          aria-label={collapsed ? "Expandir menu" : "Recolher menu"}
          title={collapsed ? "Expandir menu" : "Recolher menu"}
          onClick={onToggleCollapsed}
        >
          <span className="hk-brand-mark" aria-hidden="true">
            <i className="bi bi-whatsapp" />
          </span>
          <span className="hk-brand-text">
            <span className="bt-name">CRM</span>
            <span className="bt-sub">Atendimento &amp; IA</span>
          </span>
          <i className="bi bi-chevron-left hk-brand-caret" aria-hidden="true" />
        </button>
      </div>

      <div className="hk-sidebar-scroll">
        {groups.map((group, gi) => (
          <div className="hk-nav-group" key={gi}>
            {group.title ? <div className="hk-nav-header">{group.title}</div> : null}
            {group.items.map((item) => (
              <button
                key={item.panel}
                type="button"
                className={`hk-nav-link ${activePanel === item.panel ? "is-active" : ""}`}
                title={item.label}
                onClick={() => onSelect(item.panel)}
              >
                <span className="hk-nav-ic">
                  <i className={`bi ${item.icon}`} />
                </span>
                <span className="hk-nav-text">{item.label}</span>
                {item.badge ? <span className="hk-nav-badge">{item.badge}</span> : null}
              </button>
            ))}
          </div>
        ))}

        <div className="hk-sidebar-cta">
          <h6>WhatsApp</h6>
          <p>Status da sua conexão com os canais de atendimento.</p>
          <span className={`hk-cta-status ${connected ? "is-connected" : ""}`}>
            <span className="d" />
            {connected ? "Conectado" : status === "syncing" ? "Sincronizando" : "Desconectado"}
          </span>
        </div>
      </div>
    </aside>
  );
}
